import { Box, Divider } from '@eatclubcode/ec-component-library';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PrimaryButton } from '../../components/button/PrimaryButton';
import { formatNumber } from '../../utils';
import { formatCurrency } from '../../utils/helpers';
import useStyles from './CancelLandingPageStyles';
import RevenueSVG from '../../assets/icons/net_revenue_square.svg';
import CustomersSVG from '../../assets/icons/customers_square.svg';
import ImpressionsSVG from '../../assets/icons/impressions_square.svg';
import AovSVG from '../../assets/icons/aov_square.svg';
import CancelMembershipPage from './CancelMembershipPage';
import { primaryButtonStyles } from './CancelMembershipStyles';
import ContinueButton from './ContinueButton';

const CancelLandingPage = ({
  currentStep,
  totalSteps,
  onContinue,
  onExit,
  venueData,
  isSaving,
}) => {
  const classes = useStyles();

  return (
    <CancelMembershipPage
      currentStep={currentStep}
      totalSteps={totalSteps}
      isSaving={isSaving}
      footerLeft={
        <PrimaryButton style={primaryButtonStyles} onClick={onExit} loading={isSaving}>
          Never mind, I don&apos;t want to cancel
        </PrimaryButton>
      }
      footerRight={
        <ContinueButton onClick={onContinue} loading={isSaving}>
          Continue to cancel
        </ContinueButton>
      }
    >
      <Box className={classes.mainContent}>
        <Box className={classes.title}>
          {`Did you know you’ve earned ${formatCurrency(venueData?.totalRevenue, 0)} since you joined.`}
          {/* {venueData?.loading || venueData?.totalRevenue > 0 */}
          {/*   ? `Did you know you’ve earned ${formatCurrency(venueData?.totalRevenue, 0)} since you joined.` */}
          {/*   : `We're sorry to see you go.`} */}
        </Box>
        <Box className={classes.pageContent}>
          {venueData?.loading || venueData?.totalRevenue > 0 ? (
            <Box>
              That’s {formatNumber(venueData?.totalCustomers, 0, 'not many')} customers experiencing
              your venue. Here’s a few reasons why running a dynamic pricing strategy is critical to
              finding long term profitability as a restaurant.{' '}
            </Box>
          ) : (
            <Box>
              Here’s a few reasons why running a dynamic pricing strategy is critical to finding
              long term profitability as a restaurant.{' '}
            </Box>
          )}
          <Box className={classes.projectionItems}>
            <Divider color='#EEE9E2' />
            <Box className={classes.projectionItem}>
              <Box>Projected future revenue: 1 month</Box>
              <Box>{formatCurrency(venueData?.projectedRevenue, 0)}</Box>
            </Box>
            <Divider color='#EEE9E2' />
            <Box className={classes.projectionItem}>
              <Box>Projected future customers: 1 month</Box>
              <Box>{formatNumber(venueData?.projectedCustomers, 0)}</Box>
            </Box>
            <Divider color='#EEE9E2' />
          </Box>

          <Box className={classes.valuePoints}>
            <Box className={classes.pillar}>
              <RevenueSVG className={classes.pillarIcon} />
              <Box>Improve profitability</Box>
            </Box>
            <Box className={classes.pillar}>
              <CustomersSVG className={classes.pillarIcon} />
              <Box>Fill more tables</Box>
            </Box>
            <Box className={classes.pillar}>
              <ImpressionsSVG className={classes.pillarIcon} />
              <Box>Build brand exposure</Box>
            </Box>
            <Box className={classes.pillar}>
              <AovSVG className={classes.pillarIcon} />
              <Box>Higher customer spend </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </CancelMembershipPage>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CancelLandingPage);
